import React from 'react'
import {
  Icon,
  Input,
  Header,
  Modal,
  Image,
  Button,
  Checkbox,
  Message,
} from 'semantic-ui-react'
import logo from '../ospin.png'

type OspinModalProps = {
  children: React.ReactNode;
  header: string;
  toggle: React.ReactNode;
  open: boolean;
  onToggleModal: () => void;
  onSubmit: () => void;
  submitable: boolean;
  submitionIsLoading: boolean;
}

type UserDetailsInput = {
  handleName: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleEmail: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDeviceName: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string | undefined;
  deviceName: string | undefined;
  email: string;
  setAgreeToShareData: any;
}

type SaveDeviceResultsProps = {
  isError: boolean;
  message: string;
  hideMessage: boolean;
}

export const SaveDeviceResults: React.FC<SaveDeviceResultsProps> = (
  props: SaveDeviceResultsProps,
) => {
  const { isError, message, hideMessage } = props

  return (
    <Message color={isError ? 'red' : 'green'} hidden={hideMessage}>
      <Message.Header>
        {' '}
        { !isError ? 'Device was sent!' : 'Failed to send device'}
      </Message.Header>
      <p>
        {message}
      </p>
    </Message>
  )
}

export const UserDetailsInput: React.FC<UserDetailsInput> = (props: UserDetailsInput) => {
  const {
    name,
    deviceName,
    email,
    handleDeviceName,
    handleName,
    handleEmail,
    setAgreeToShareData,
  } = props

  return (
    <>
      <label htmlFor='EmailInput' style={{ fontSize: '1.2rem ' }}>Email (Required)</label>
      <Input name='EmailInput' style={{ width: '100%' }} size='large' icon>
        <input
          autoComplete='off'
          type='email'
          data-testid='EmailInput'
          required
          style={{ boxShadow: 'inset 0 0 4px 0 hsla(0, 0%, 0%, 0.2)' }}
          value={email}
          onChange={(e): void => handleEmail(e)}
        />
        <Icon style={{ fontSize: '1.5rem' }} name='mail' />
      </Input>
      <br />
      <br />

      <label id='NameInput' htmlFor='NameInput' style={{ fontSize: '1.2rem ' }}>Name (Optional)</label>
      <Input style={{ width: '100%' }} size='large' icon>
        <input
          autoComplete='off'
          type='text'
          data-testid='NameInput'
          style={{ boxShadow: 'inset 0 0 4px 0 hsla(0, 0%, 0%, 0.2)' }}
          name='NameInput'
          value={name || ''}
          onChange={(e): void => handleName(e)}
        />
        <Icon style={{ fontSize: '1.5rem' }} name='address book' />
      </Input>
      <br />
      <br />
      <label htmlFor='DeviceNameInput' style={{ fontSize: '1.2rem ' }}>Device Name (Optional)</label>
      <Input name='DeviceNameInput' style={{ width: '100%' }} size='large' icon>
        <input
          autoComplete='off'
          type='text'
          data-testid='DeviceNameInput'
          style={{ boxShadow: 'inset 0 0 4px 0 hsla(0, 0%, 0%, 0.2)' }}
          value={deviceName || ''}
          onChange={(e): void => handleDeviceName(e)}
        />
        <Icon style={{ fontSize: '1.5rem' }} name='hdd' />
      </Input>
      <br />
      <br />
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Checkbox label='Do you agree to share your email with OSPIN?' onClick={setAgreeToShareData} />
      </div>
    </>
  )
}

const OspinModal: React.FC<OspinModalProps> = (props: OspinModalProps) => {
  const {
    toggle,
    open,
    header,
    children,
    onToggleModal,
    onSubmit,
    submitable,
    submitionIsLoading,
  } = props

  const submitButtonColor = submitable === true ? 'green' : 'grey'

  return (
    <Modal trigger={toggle} open={open}>
      <Modal.Header style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
        backgroundColor: '#F9F9F9',
      }}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Image style={{ width: '3rem', margin: 'auto', height: '3rem' }} src={logo} />
          <Header style={{ margin: 'auto' }}>{header}</Header>
        </div>
      </Modal.Header>
      <Modal.Content>
        {children}
        <Button.Group style={{ float: 'right', margin: '10px 0px 10px' }}>
          <Button color='red' onClick={(): void => onToggleModal()}>Close</Button>
          <Button.Or />
          <Button
            disabled={!submitable}
            color={submitButtonColor}
            onClick={(): void => onSubmit()}
            data-testid='SubmitModal'
            loading={submitionIsLoading}
          >
            Submit
          </Button>
        </Button.Group>
      </Modal.Content>
    </Modal>
  )
}

export default OspinModal
